import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { EnumService } from './enum.service';
import { OrderStatusEnum } from '../enums/status.enum';
import { Params } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class StatusSelectorService {
    enumService = inject(EnumService);
    statusOptions = this.enumService.enumTranslateStatusToArrSelects(OrderStatusEnum);

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        const statusOptions = this.statusOptions.filter(statusOption => statusOption.label.includes(query['search']));
        // Преобразуем данные к нужному формату, исключая undefined значения
        const mappedData: ILabelValue[] = statusOptions
            .filter(option => option.value !== undefined)
            .map(option => ({
                label: option.label,
                value: option.value as string,
                tooltip: option.label
            }));

        const response: IPaginatedResponse<ILabelValue> = {
            data: mappedData,
            links: {},
            meta: {
                itemsPerPage: mappedData.length,
                totalItems: mappedData.length,
                currentPage: 1,
                totalPages: 1
            }
        };

        return of(response);
    }

    getOptionsByValue(optionValue: string): Observable<ILabelValue> {
        const allStatuses = this.enumService.enumTranslateStatusToArrSelects(OrderStatusEnum);
        const foundStatus = allStatuses.find(status => status.value === optionValue);

        if (!foundStatus || foundStatus.value === undefined) {
            throw new Error(`Status with value ${optionValue} not found`);
        }

        return of({
            label: foundStatus.label,
            value: foundStatus.value as string,
            tooltip: foundStatus.label
        });
    }

}
